<template>
  <div>
    <v-card class="sf-card"
            flat>
      <div class="sf-card__header">
        <h2 class="sf-card__title">{{ $t('customers') }}</h2>
        <div class="sf-card__tools">
          <v-text-field class="sf-search sf-analytics__search"
                        dense
                        flat
                        hide-details
                        prepend-inner-icon="ti-search"
                        solo
                        v-bind:placeholder="$t('search')"
                        v-model="search" />
        </div>
      </div>
      <v-data-table v-bind:custom-filter="filter"
                    v-bind:headers="headers"
                    v-bind:items="customers"
                    v-bind:items-per-page="15"
                    v-bind:no-data-text="$t('thereAreCurrentlyNoOrders')"
                    v-bind:no-results-text="$t('noOrdersWereFound')"
                    v-bind:search="search"
                    v-bind:sort-by="['companyName']">
        <template v-slot:item.actions="{ item }">
          <v-btn color="primary"
                 icon
                 small
                 v-bind:title="$t('edit')"
                 v-bind:to="{ name: 'administration-customer', params: { id: item.id } }">
            <v-icon small>
              ti-pencil
            </v-icon>
          </v-btn>
        </template>
        <template v-slot:item.orderCount="{ item }">
          <span class="sf-tabular">{{ item.orderCount }}/{{ item.maxOrder }} <strong>({{ percent(item.orderCount, item.maxOrder) }})</strong></span>
        </template>
        <template v-slot:item.orderCount2="{ item }">
          <span class="sf-tabular">{{ item.orderCount2 }}/{{ item.maxOrder }} <strong>({{ percent(item.orderCount2, item.maxOrder) }})</strong></span>
        </template>
        <template v-slot:item.newOrderCount="{ item }">
          <span class="sf-tabular">{{ item.newOrderCount }}/{{ item.newMaxOrder }} <strong>({{ percent(item.newOrderCount, item.newMaxOrder) }})</strong></span>
        </template>
        <template v-slot:item.newOrderCount2="{ item }">
          <span class="sf-tabular">{{ item.newOrderCount2 }}/{{ item.newMaxOrder }} <strong>({{ percent(item.newOrderCount2, item.newMaxOrder) }})</strong></span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  export default {
    data: () => ({
      search: null
    }),
    computed: {
      headers() {
        return [
          {
            text: this.$t('customerNumber'),
            value: 'id'
          },
          {
            text: this.$t('companyName'),
            value: 'companyName'
          },
          {
            text: this.$t('all'),
            value: 'orderCount'
          },
          {
            text: this.$t('all2'),
            value: 'orderCount2'
          },
          {
            text: this.$t('new'),
            value: 'newOrderCount'
          },
          {
            text: this.$t('new2'),
            value: 'newOrderCount2'
          },
          {
            sortable: false,
            text: '',
            value: 'actions'
          }
        ]
      }
    },
    methods: {
      filter(value, search, item) {
        if (value == null) {
          return null
        }

        if (search == null) {
          return null
        }

        return value.toString().toLocaleUpperCase().indexOf(search.toString().toLocaleUpperCase()) !== -1
      },
      percent(total, count) {
        if (total == null || total === 0) {
          return '-'
        }

        return Math.floor(total / count * 100) + ' %'
      }
    },
    name: 'CustomerAnalyticsCard',
    props: {
      customers: Array
    }
  }
</script>

<style scoped>
  .sf-analytics__search {
    flex: 1 1 200px;
    max-width: 320px;
  }
</style>

<i18n>
  {
    "de": {
      "all": "Alle Z1",
      "all2": "Alle Z2",
      "companyName": "Firmenname",
      "customerNumber": "Kundennr.",
      "customers": "Kunden",
      "new": "Neu Z1",
      "new2": "Neu Z2",
      "noOrdersWereFound": "Es wurden keine Bestellungen gefunden",
      "thereAreCurrentlyNoOrders": "Es sind noch keine Bestellungen vorhanden",
      "search": "Suchen",
      "edit": "Bearbeiten"
    },
    "en": {
      "all": "All T1",
      "all2": "All T2",
      "companyName": "Company name",
      "customerNumber": "Customer number",
      "customers": "Customers",
      "new": "New T1",
      "new2": "New T2",
      "noOrdersWereFound": "No orders were found",
      "thereAreCurrentlyNoOrders": "There are currently no orders",
      "search": "Search",
      "edit": "Edit"
    }
  }
</i18n>